import { DOCTORS_IN_QUEUE, PATIENTS_IN_QUEUE } from "../constants/queueCount";

export const updatePatientsInQueue = data => ({
  type: PATIENTS_IN_QUEUE,
  payload: data
});

export const updateDoctorsInQueue = data => ({
  type: DOCTORS_IN_QUEUE,
  payload: data
});
